import { Box, IconButton, Typography } from '@mui/material';

import { getIconByType, getTitleIconByType } from '~/components/organisms/previewBar/components/vcard-plus/utils';
import { COLORS } from '~/styles/colors';

type VCardPreviewContactInfoProps = {
  content: any;
  scrollToSection?: (section: string) => void;
  backgroundColor?: string;
  containerJustifyContent?: string;
  labelColor?: string;
  isFullRounded?: boolean;
  isAnonymous?: boolean;
};

export default function VCardPreviewContactInfo({
  content,
  scrollToSection,
  backgroundColor,
  containerJustifyContent = 'center',
  labelColor = COLORS.white,
  isFullRounded = false,
  isAnonymous = false,
}: VCardPreviewContactInfoProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: containerJustifyContent,
        alignItems: 'center',
        gap: '24px',
      }}
    >
      {['phone', 'email', 'geo'].map((item) => {
        const label = content[`${getTitleIconByType(item)}`];

        if (label) {
          return (
            <Box
              key={item}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <IconButton
                color="secondary"
                size="small"
                sx={{
                  width: isAnonymous ? '36px' : '28px',
                  height: isAnonymous ? '36px' : '28px',
                  backgroundColor,
                  borderRadius: isFullRounded ? '50%' : '3px',
                  '&:hover': {
                    backgroundColor,
                  },
                }}
                onClick={() => scrollToSection(item)}
              >
                {getIconByType(item, COLORS.white, isAnonymous ? 18 : 13)}
              </IconButton>
              <Typography
                sx={{ wordBreak: 'break-word', fontSize: isAnonymous ? '10px' : '7px', pt: 1, color: labelColor }}
              >
                {label}
              </Typography>
            </Box>
          );
        }

        return null;
      })}
    </Box>
  );
}
